export default "__VITE_ASSET__BoTDm4$P__"